var React = require('react');

function StrictIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.011 16.5C1.273 10.657 6.093 6 12.001 6c3.037 0 5.787 1.231 7.777 3.222l-1.934 1.934A9 9 0 0 0 2.014 16.5a.522.522 0 0 1-.514.5.483.483 0 0 1-.489-.5zm18.433-2.622c.193.522.339 1.066.433 1.628.136.817.795 1.494 1.623 1.494s1.51-.675 1.4-1.496a10.931 10.931 0 0 0-1.547-4.297l-1.909 2.671z","fill":"#fff","key":0}),React.createElement("path",{"d":"m22 7-8.593 10.502a1.357 1.357 0 1 1-1.91-1.91L22 7z","fill":"#fff","key":1})]);
}

StrictIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = StrictIcon;

StrictIcon.default = StrictIcon;
